<template>
  <div class="content if-profile report-tab">
    <div class="md-layout financal-report">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header m-0">
         <VRHeader :headerData="this.headerData"/>
      </div>
      <div class="md-layout-item p-0">
        <md-card class="if_card">
          <div class="md-layout">
            <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
              <md-card-header class="md-card-header-icon">
                Valuation Approach
              </md-card-header>
            </div>
          </div>
          <md-card-content>
            <div class="md-layout p-4">
              <div class="md-layout-item md-medium-size-100 md-size-50">
                <profile-card header-color="blue" class="text-card scores-list-star">
                  <template slot="header" header-color="rose">
                    <h4 class="title m-0">
                      <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                        General
                      </div>
                    </h4>
                  </template>
                  <template slot="content">
                    <!-- <h4 class="Performance Scores">General<br /></h4> -->
                    <div class="extra_space">
                      <p>
                        Bizminer Valution reports help you understand the
                        value of any firm simply and quickly. No other
                        electronic valuation tool organizes critical
                        information with the level of data integrity and
                        industry detail that results from the integration of
                        Bizminer’s widely-recognized industry financial and
                        market analysis content and its derivative analysis of
                        30,000 recent business transactions from the DealStats
                        database. Both the Bizminer and DealStats datasets are
                        key components in the analytical toolbox of thousands
                        of certified business valuation professionals. </p>
                      <p>Valution data sources are distinct and
                        transparent; our financial analysis is utilized by
                        thousands of accounting, valuation, banking and
                        business assistance professionals; by almost one
                        hundred university libraries and by taxing agencies in
                        multiple countries. You won’t find a lot of jargon and
                        overblown claims in our Valution Business Value
                        Reports —just the hard analysis and clear answers you
                        need.</p>
                      <p>Valution analytical content is updated regularly
                        using the same tested protocols applied to our
                        Industry Market Trend reports, which cover over 9000
                        industry classifications; and to the trusted industry
                        financial analysis we present for more than 5000 lines
                        of business. Uniquely among published electronic value
                        calculations, the Valution analysis integrates
                        traditional financial metrics with market opportunity
                        and growth analyses from Bizminer’s recognized
                        Industry Market dataset.</p>
                      <p>Your Valuation report includes definitions of
                        every line item and ratio, as well as a simple scoring
                        interface that compares your firm’s performance to the
                        industry peer group.</p>
                      <p>When you accessed your Valution Report, you chose
                        a comparison peer group that most closely represents
                        the character of your firm. Your peer group is defined
                        by a series of criteria that reflects your selections
                        of:</p>
                        <ul>
                          <li>Industry Segment:[{{ parseFloat(this.headerData.bznaics) }}] {{ this.headerData.industry }}</li>
                          <li>Market Analysis Area:{{this.headerData.area}}</li>
                          <li>Sales Class: {{this.headerData.sales_class}}</li>
                        </ul>
                      <p>This report is additionally conditioned by the
                        selection and active integration of 3 of three
                        potential years of firm inputs. While the
                        Valution report offers integrated scoring of 13
                        financial and market KPIs, only those scored on P4
                        were selected by the developer for activation.</p>
                      <p>The Valution report is an informational tool, not
                        a guide to action. Do not use the report in place of a
                        certified valuation, or as the basis of any specific
                        business-related or other financial transaction. For
                        that we recommend obtaining an appraisal from a
                        business broker, a valuation from a certified
                        valuation professional, or both. You should not
                        attempt to use Valution to secure a business or
                        personal loan. Be aware that the Valution report
                        may not consider market or firm idiosyncrasies that
                        can influence the actual value or selling price.
                      </p>
                    </div>
                  </template>
                </profile-card>
                <profile-card header-color="blue" class="text-card scores-list-star other-value">
                  <template slot="header" header-color="rose">
                    <h4 class="title m-0">
                      <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                        Business Value Approaches
                      </div>
                    </h4>
                  </template>
                  <template slot="content">
                    <div class="extra_space">
                      <p>
                        Valution reports develop both "asset sale" and
                        "equity sale" values for earnings and revenue approach
                        valuation methods. These approaches are coupled with
                        benchmarks for key financial ratios and market metrics
                        which compare the analyzed firm’s liquidity,
                        profitability, efficiency, debt-risk performance and
                        market opportunity to industry peer group standards.
                        The result is a meaningful analysis and final value
                        estimates that make sense in the real world, providing
                        useful information to valuation professionals,
                        brokers, sellers, entrepreneurs, investors and
                        advisors. </p>
                        <ul>
                          <li>
                            {{this.naics}}: {{this.industryName}}
                          </li>
                        </ul>
                    </div>
                  </template>
                </profile-card>
              </div>
              <div class="md-layout-item md-medium-size-100 md-size-50">
                <profile-card header-color="blue" class="text-card scores-list-star other-value">
                  <template slot="header" header-color="rose">
                    <h4 class="title m-0">
                      <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                        Your Industry in Context: The NAICS Classification System
                      </div>
                    </h4>
                  </template>
                  <template slot="content">
                    <div class="extra_space">
                      <p>
                        The industry you selected fits within the official
                        NAICS (North American Industry Classification System)
                        and Bizminer’s proprietary taxonomy, which breaks out
                        more detailed industries classifications than the
                        NAICS by adding up to eight decimal digits after the
                        NAICS-6 code. The selected industry fits into this
                        hierarchy: <br />
                      </p>
                      <ul>
                        <li v-for="item in this.industryRollup" :key="item">{{item}}</li>
                        
                      </ul>
                    </div>
                  </template>
                </profile-card>
                <profile-card header-color="blue" class="text-card scores-list-star other-value">
                  <template slot="header" header-color="rose">
                    <h4 class="title m-0">
                      <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                        Ratio Categories
                      </div>
                    </h4>
                  </template>
                  <template slot="content">
                    <div class="extra_space">
                      <p>
                        The Valution Business Value Report benchmarks
                        pivotal industry peer group financial ratio values
                        against the performance of your firm, then integrates
                        the results into the overall analysis and
                        calculations. These ratios (also known as KPIs or Key
                        Performance Indicators) fall into five categories:</p>
                        <ul>
                          <li>
                            Cash Flow/Solvency:
                            <p>Cash Flow ratios indicate a
                            company’s ability to meet various levels of demand on
                            cash and easily obtainable cash resources against
                            current and anticipated near-term payments due.</p>
                          </li>
                          <li>Profitability:
                            <p>Profitability ratios compare
                            levels of return against various expense and balance
                            sheet components to measure your performance against
                            reasonable industry peer group standards, indicating
                            bottom line performance.</p>
                          </li>
                          <li>Efficiency:
                            <p>Efficiency ratios measure your
                            success in marshalling resources-at-hand to
                            effectively manage various components of your business
                            operations. These indicators often point toward
                            specific actions that could enhance your bottom
                            line.</p>
                          </li>
                          <li>Debt-Risk:
                            <p>Debt-Risk ratios assess the
                            appropriateness of a firm’s level of debt against the
                            ability to pay, as well as the risk of insolvency.</p>
                          </li>
                          <li>Market Opportunity:
                            <p>These non-traditional
                            financial metrics assess overall market vitality and
                            opportunity.</p>
                          </li>
                        </ul>
                      <p>Depending on subject firm inputs you make, the ratios
                        will be scored against industry values for up to three
                        recent calendar years.</p>
                      <p>Financial ratios are calculated for the subject firm
                        when you submit the necessary inputs. Firm ratio
                        benchmarks are scored on a 1-5 scale based on their
                        variance from industry peer group standards. While the
                        report presents starred scores for ease of display,
                        final value calculations are more finely calibrated
                        and applied based on each percentage point of variance
                        from the industry norm. For more details, see About
                        the Data—Our Approach to Scoring.</p>
                    </div>
                  </template>
                </profile-card>
                <profile-card header-color="blue" class="text-card scores-list-star other-value">
                  <template slot="header" header-color="rose">
                    <h4 class="title m-0">
                      <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                        Key Performance Indicators—Financial Ratios
                      </div>
                    </h4>
                  </template>
                  <template slot="content">
                    <div class="extra_space">
                      <p>
                        To better understand your company’s operations, the
                        Valution Report calculates Key Performance
                        Indicators (KPIs) for review and comparison to
                        industry benchmarks.</p>
                      <p>KPIs (also known as financial ratios) are calculated
                        on the basis of company-specific data linked to the
                        corresponding values of the selected industry peer
                        group. These and other derivative metrics that form
                        the basis of our analysis are developed from a variety
                        of raw data sources detailed in the Methodology
                        section of this report.</p>
                      <p>KPls are useful measures of the overall financial and
                        operational health and growth of your business. These
                        same measures are commonly utilized by business
                        coaches, financial professionals and potential
                        business acquirers in a variety of real world
                        settings. The Valution report applies KPI scoring
                        to the calculation of business worth as variance-based
                        values to which various weights are assigned based on
                        the specific metric, years of inputs and variance.</p>
                      <p>In addition to detailing KPI variances and applying a
                        calibrated weight to each percent of difference from
                        industry peer group standards, we use an intuitive
                        five-star scoring system to communicate firm
                        performance against industry peer group standards.
                        Except for Days Payable and Days Receivable, KPIs are
                        scored on a “higher is better” basis. The scoring
                        approach is also detailed in the Methodology section
                        (VII) of this report.</p>
                    </div>
                  </template>
                </profile-card>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import VRHeader from './_partials/VRHeader';
import { ProfileCard } from "@/components";
import {mapState} from "vuex";

export default {
  name: "vr-vestimate-approachd",
  components: {
    ProfileCard,
    VRHeader,
  },
  props: ['headerData'],
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      client: (state) => state.user.vestimate_report.data.developerClient,
      vestimateReport: state => state.user.vestimate_report.data,
      naics: state => state.user.vestimate_report.data.IMRnaics,
      industryRollup: state =>  state.user.vestimate_report.data.industry_rollup,
      industryName: state => state.user.vestimate_report.data.IMRindustry,
      displayArea: state => state.user.vestimate_report.data.MR.area,
      reportDate: state => state.user.vestimate_report.data.report_date,
      companyName: state => state.user.vestimate_report.data.input_structure['Company Name']['value']
    }),
  },
  methods: {},
};
</script>
<style lang="scss">
.scores-list-star {
  .md-list {
    .md-list-item-content {
      min-height: 45px !important;
      .md-button-content {
        .md-icon {
          color: #3b7ef1;
        }
      }
    }
  }
}

.scores-list-star.other-value {
  .md-list {
    border-bottom: 1px solid #ddd;
  }
}
</style>
